module.exports = "/_next/static/images/mokubaza_curry-28ba28e5315d683a99819ffa4f9f0428.jpg";